import SMSSettingsTab from './sms-settings';

export default SMSSettingsTab;
